<div class="vessel-name">
    <label class="form-group__label">
        {{ vesselName }} ( {{ imoNumber }} )
    </label>
</div>